import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";

const LineChart = ({ data, isCustomLineColors = false, isDashboard = false, hideAxisLabels }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  
    return (
      <ResponsiveLine
        data={data}
        theme={{
          background: "transparent",
          axis: {
            domain: { line: { stroke: colors.grey[700] } },
            legend: { text: { fill: colors.grey[500], fontSize: 11, fontWeight: 700 } },
            ticks: {
              line: { stroke: colors.grey[700], strokeWidth: 1 },
              text: { fill: colors.grey[500], fontSize: 11, fontWeight: 600 },
            },
          },
          grid: { line: { stroke: colors.grey[800], strokeWidth: 1 } },
          legends: { text: { fill: colors.grey[300], fontWeight: 700 } },
          tooltip: {
            container: {
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(17,19,24,0.08)"}`,
              borderRadius: 10,
              boxShadow: "0 18px 44px rgba(0,0,0,0.22)",
              color: colors.grey[100],
            },
          },
        }}
        colors={isDashboard ? { datum: "color" } : { scheme: "nivo" }}
        margin={{ top: 26, right: 96, bottom: 54, left: 54 }}
        xScale={{ type: "point" }}
        yScale={{
          type: "linear",
          min: "auto",
          max: "auto",
          stacked: true,
          reverse: false,
        }}
        yFormat=" >-.2f"
        curve="catmullRom"
        axisTop={null}
        axisRight={null}
        axisBottom={
            hideAxisLabels
              ? {
                  tickValues: [data[0].data[0].x, data[0].data[data[0].data.length - 1].x], // Show only first and last
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "",
                  legendOffset: 36,
                  legendPosition: "middle",
                }
              : {
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: -45,
                  legend: "Date",
                  legendOffset: 36,
                  legendPosition: "middle",
                }
          }
        axisLeft={{
          orient: "left",
          tickValues: 5,
          tickSize: 3,
          tickPadding: 5,
          tickRotation: 0,
          legend: isDashboard ? undefined : "Transactions",
          legendOffset: -40,
          legendPosition: "middle",
        }}
        enableGridX={false}
        enableGridY={true}
        gridYValues={5}
        lineWidth={3}
        pointSize={7}
        pointColor={theme.palette.background.paper}
        pointBorderWidth={2}
        pointBorderColor={{ from: "serieColor" }}
        pointLabelYOffset={-12}
        useMesh={true}
        legends={[
          {
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: "left-to-right",
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: "circle",
            symbolBorderColor: "rgba(0, 0, 0, .5)",
            effects: [
              {
                on: "hover",
                style: {
                  itemBackground: "rgba(0, 0, 0, .03)",
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    );
  };
  
  export default LineChart;
  
